<template>
  <div class="rolemanagetable">
    <el-table
      :data="tableData"
      style="width: 100%;padding:10px 10px 0 10px;"
      border>
      <el-table-column
        prop="createAtMY"
        label="分享时间"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
      >
        <template slot-scope="scope">
          <el-button @click="openDesc(scope)"
                     style="color: #5b9bd1;"
                     type="text"
                     class="btn"
                     size="small">{{scope.row.title}}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="pictureCount"
        label="图片数量"
        width="70"
      >
      </el-table-column>
      <el-table-column
        prop="targetWorkgroupId"
        label="分享渠道"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.targetWorkgroupId !== 0">
            <span>分享到工作圈</span>
          </div>

          <div v-else>
            <span>分享到其他</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="mode"
        v-if="false"
        label="分享模式"
      >
        <template slot-scope="scope">
          <div>暂无数据</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="time"
        v-if="false"
        label="浏览次数"
      >
        <template slot-scope="scope">
          <div>暂无数据</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="250">
        <template slot-scope="scope">
          <!-- <div>无</div> -->
          <el-button @click="seePic(scope)" type="text" style="color:#3086F0;font-weight:bold;font-size:13px;" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-picture-outline"></i>查看图片</el-button>
          <!-- <div v-if="scopeIndex.indexOf(scope.$index) > -1">
            <el-button @click="closeClick(scope)" type="text" class="btn" size="small">关闭</el-button>
            <span style="margin:0 8px;"> | </span>
            <el-button @click="changeClick(scope)" type="text" class="btn" size="small">外链</el-button>
            <span style="margin:0 8px;"> | </span>
            <el-button @click="removeClick(scope)" type="text" class="btn" size="small">二维码</el-button>
          </div>

          <div v-if="scopeIndex.indexOf(scope.$index) === -1">
            <el-button @click="openClick(scope)" type="text" class="btn" size="small">开启</el-button>
            <span style="margin:0 8px;"> | </span>
            <el-button @click="changeClick(scope)" type="text" class="btn" size="small">修改</el-button>
          </div> -->
        </template>

          
      </el-table-column>

    </el-table>


    <el-dialog :visible.sync="descDialog"
               width="30%"
               :before-close="handleClosedesc">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>查看备注</div>
      </div>
      <div>
        <span>{{desc || '暂无'}}</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'rolemanagetable',
  props: {
    tableData:Array,
  },
  data(){
    return {
      scopeIndex:[],
      descDialog:false,
      desc:""
      // tableData:[
      //   {
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'523',
      //     mode:'内部分享',
      //     time:'12次'
      //   },
      //   {
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'523',
      //     mode:'内部分享',
      //     time:'12次'
      //   },
      //   {
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'523',
      //     mode:'内部分享',
      //     time:'12次'
      //   },
      //   {
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'523',
      //     mode:'内部分享',
      //     time:'12次'
      //   },
      // ]
    }
  },
  methods:{
    openClick(scope){
      this.scopeIndex.push(scope.$index)
      
    },

    handleClosedesc(){
      this.desc = ''
      this.descDialog = false
    },
    openDesc (scope) {
      this.desc = JSON.parse(scope.row.shareConfig).note
      this.descDialog = true;
    },

    closeClick(scope){
      let index = this.scopeIndex.indexOf(scope.$index)
      this.scopeIndex.splice(index,1)
      // this.$emit('authClick',scope)
    },
    changeClick(scope){
      this.$emit('changeClick',scope)
    },
    seePic(scope){
      this.$emit('seePic',scope)
    },
    removeClick(scope){
      this.$emit('removeClick',scope)
    },
  },
  created(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
.table{
  width: auto;
}
.btn:hover{
  text-decoration: underline;
}
</style>
